import React, { useState, useEffect } from "react";
import { Box, Grid, Button } from "@mui/material";
import { HashLink } from "react-router-hash-link";
import SubtotalCheckout from "./SubtotalCheckout";

import { useStateContext } from "../../../../context/StateContext_US";
import { useAuth } from "../../../../context/AuthContext";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import EnterEmail from "./EnterEmail";
import EnterAddress from "./EnterAddress";
import EnterPayment from "./EnterPayment";
import EnterShippingOption from "./EnterShippingOption";
import { functions, httpsCallable } from "../../../../firebase";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";

const stripePromise = loadStripe("pk_test_K5rH66ftn5QWFMNxkcEmsdgw");
var SalesTax = require("sales-tax");
// const steps_us = ["Email Address", "Address", "Shipping Options", "Payment"];
// const steps_ko = ["이메일 주소 입력", "배송지 주소", "택배 선택", "계산 하기"];

const Checkout = () => {
  const { t, i18n } = useTranslation();
  const [steps, setSteps] = useState([
    "Email Address",
    "Address",
    "Shipping Options",
    "Payment",
  ]);

  useEffect(() => {
    // if (i18n.resolvedLanguage === "ko") {
    //   setSteps(["이메일 주소 입력", "배송지 주소", "택배 선택", "계산 하기"]);
    // } else {
    // setSteps([
    //   t("Email Address"),
    //   t("Address"),
    //   t("Shipping Options"),
    //   t("Payment"),
    // ]);
    // }
  }, []);

  console.log(steps);

  console.log(i18n);
  const {
    basket,
    setEmailInBasket,
    setTax,
    shippingOption,
    setShipingOption,
    getBasketTotal,
    tax,
    getShipping,
    getSubtotal,
    taxPrice,
  } = useStateContext();

  const [value, setValue] = useState();
  const [refresh, setRefresh] = useState(true);
  const [shipping, setShipping] = useState("Standard");
  const { currentUser } = useAuth();
  const [guestPassword, setGuestPassword] = useState(null);

  const refreshComp = () => {
    console.log("refreshComp");
    setValue({});
  };

  const createStripeCheckout = httpsCallable(functions, "createStripeCheckout");
  const createStripeCheckoutGuest = httpsCallable(
    functions,
    "createStripeCheckoutGuest"
  );

  const [shippingAddress, setShippingAddress] = useState(null);
  const [email, setEmail] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [step, setStep] = useState(0);

  console.log("guestPassword", guestPassword);
  console.log(
    "checkout_guestPassword",
    sessionStorage.getItem("checkout_guestPassword")
  );

  useEffect(() => {
    sessionStorage.setItem("checkout_guestPassword", guestPassword);
    sessionStorage.setItem("checkout_basket", JSON.stringify(basket));
    sessionStorage.setItem("checkout_email", email);
    sessionStorage.setItem("checkout_tax_rate", tax);
    sessionStorage.setItem("checkout_total", getBasketTotal());
    sessionStorage.setItem("checkout_shippingOption", shippingOption);
    sessionStorage.setItem("checkout_shippingPrice", getShipping()); // shipping price
    sessionStorage.setItem("checkout_subtotal", getSubtotal());
    sessionStorage.setItem("checkout_taxprice", taxPrice);
    sessionStorage.setItem(
      "checkout_shippingFirstname",
      shippingAddress?.firstname
    );
    sessionStorage.setItem(
      "checkout_shippingLastname",
      shippingAddress?.lastname
    );
    sessionStorage.setItem(
      "checkout_shippingAddress",
      shippingAddress?.address
    );
    sessionStorage.setItem("checkout_shippingApt", shippingAddress?.apt);
    sessionStorage.setItem("checkout_shippingCity", shippingAddress?.city);
    sessionStorage.setItem("checkout_shippingState", shippingAddress?.state);

    sessionStorage.setItem(
      "checkout_shippingZipcode",
      shippingAddress?.zipcode
    );
    if (currentUser) {
      sessionStorage.setItem("checkout_userUID", currentUser.uid);
    } else {
      sessionStorage.removeItem("checkout_userUID");
    }
  }, [
    email,
    tax,
    getBasketTotal,
    shippingAddress,
    shippingOption,
    getShipping,
    getSubtotal,
    basket,
    taxPrice,
    currentUser,
    guestPassword,
  ]);
  console.log("clientSecret", clientSecret);

  useEffect(() => {
    setEmailInBasket(email);
  }, [email, setEmailInBasket]);

  useEffect(() => {
    if (shippingAddress) {
      if (shippingAddress.state.toUpperCase() === "NY") {
        SalesTax.getSalesTax("US", "NY").then((tax) => {
          setTax(tax.rate);
          // calcTax(tax.rate);
        });
      } else {
        setTax(0);
        // calcTax(0);
      }
    }
  }, [shippingAddress]);

  useEffect(() => {
    const getSecret = async () => {
      // console.log("================= getBasketTotal", getBasketTotal());
      let total = (Number(getBasketTotal()).toFixed(2) * 100).toFixed();
      // console.log(
      //   "Number(getBasketTotal()).toFixed(2) * 100",
      //   Number(getBasketTotal()).toFixed(2) * 100
      // );
      // console.log("total", total);
      // console.log("email", email);

      // if (stripeUserId) {
      //   console.log("createStripeCheckout", createStripeCheckout);
      //   createStripeCheckout({
      //     amount: total,
      //     customer: window.sessionStorage.getItem("stripeUserId"),
      //     email: currentUser?.email,
      //   })
      //     .then((result) => {
      //       // console.log("result", result);
      //       setClientSecret((old) => result.data.paymentIntent.client_secret);
      //     })
      //     .catch((error) => console.log(error));
      // } else {
      // console.log("createStripeCheckoutGuest", createStripeCheckoutGuest);
      if (email)
        createStripeCheckoutGuest({
          amount: total,
          email: email,
        })
          .then((result) => {
            console.log("result.data.paymentIntent", result.data.paymentIntent);
            setClientSecret((old) => result.data.paymentIntent.client_secret);
          })
          .catch((error) => console.log(error));
      // }
      // console.log("===========");
      // console.log("stripeUserId", stripeUserId);
      // console.log("total", total);
      // console.log("currentUser", currentUser);
      // console.log("clientSecret", clientSecret);
      // console.log("===========");
    };
    getSecret();
  }, [getBasketTotal, shippingAddress, email]);

  useEffect(() => {
    setRefresh((refresh) => !refresh);
  }, [clientSecret]);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };

  const goToNextStep = () => {
    setStep((step) => step + 1);
  };
  const goToPreviousStep = () => {
    setStep((step) => step - 1);
  };
  const goToFirstStep = () => {
    setStep(0);
  };
  const goToStepOne = () => {
    setStep(0);
  };
  const goToStepTwo = () => {
    setStep(1);
  };

  return (
    <Fade delay={500}>
      <Grid
        container
        sx={{
          maxWidth: "1200px",
          marginLeft: "auto",
          marginRight: "auto",
          px: { md: 0, sm: 2, xs: 2 },
        }}
      >
        <Grid item md={4} sm={12}>
          <Box sx={{ mt: 7 }}>
            <Box sx={{ backgroundColor: "#f6f6f6", p: 2 }}>
              <Box className="menu_bredcrumb">
                <HashLink smooth to="/">
                  {t("bread_home")}{" "}
                </HashLink>
                /{" "}
                <HashLink smooth to="/products#top">
                  {t("bread_cart")}
                </HashLink>
              </Box>
              <Box
                sx={{
                  fontSize: "19px",
                  color: "#153a5b",
                  pt: 2,
                }}
              >
                {t("Order Summary")}
              </Box>
              <SubtotalCheckout noShipping={true} />
            </Box>
          </Box>

          <Box sx={{ pt: 2 }}>
            {basket?.map((basketEach, idx) => {
              return (
                <Box
                  key={idx}
                  sx={{ paddingTop: "10px", display: "flex", pl: 4 }}
                >
                  <Box>
                    <img src={basketEach.image} alt="" width="40" height="40" />
                  </Box>
                  <Box
                    sx={{
                      fontSize: "11px",
                      fontWeight: "bold",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      paddingLeft: "10px",
                    }}
                  >
                    <Box sx={{ color: "#153a5b" }}>
                      {basketEach.quantity} x {basketEach.name}
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Box
            sx={{
              fontSize: "13px",
              marginTop: "100px",

              color: "#153a5b",
              display: "flex",
              alignItems: "center",
              fontFamily: "Tahoma",
            }}
          >
            <Box>
              <a href="https://stripe.com/" rel="noreferrer" target="_blank">
                Powered by
                <img
                  src="img/Stripe-blurple.svg"
                  width="50"
                  alt="stripe"
                  style={{ position: "relative", top: "+6px" }}
                />
              </a>
            </Box>
            <Box sx={{ paddingTop: "3px" }}>|</Box>
            <Box sx={{ paddingTop: "4px", pl: 2 }}>
              <HashLink target="_blank" to="/terms-and-condition">
                Terms
              </HashLink>
            </Box>
            <Box sx={{ paddingTop: "4px", pl: 2 }}>
              <HashLink target="_blank" to="/privacy">
                Privacy
              </HashLink>
            </Box>
            <Box sx={{ paddingTop: "4px", pl: 2 }}>
              <HashLink target="_blank" to="/return">
                Returns
              </HashLink>
            </Box>
          </Box>
        </Grid>
        <Grid item sm={12} md={8} sx={{ pt: 10 }}>
          <Stepper activeStep={step} alternativeLabel>
            {steps?.map((label, index) => (
              <Step key={label} sx={{ fontSize: "12px" }}>
                <StepLabel sx={{ fontSize: "12px" }}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {step === 0 ? (
            <Fade delay={300}>
              <EnterEmail
                setGuestPassword={setGuestPassword}
                email={email}
                goToNextStep={goToNextStep}
                goToStepOne={goToStepOne}
                setEmail={setEmail}
              />
            </Fade>
          ) : null}
          {step === 1 ? (
            <Fade delay={300}>
              <EnterAddress
                email={email}
                shipping={shipping}
                goToFirstStep={goToFirstStep}
                goToNextStep={goToNextStep}
                goToPreviousStep={goToPreviousStep}
                setShippingAddress={setShippingAddress}
                shippingAddress={shippingAddress}
              />
            </Fade>
          ) : null}
          {step === 2 ? (
            <Fade delay={300}>
              <EnterShippingOption
                email={email}
                shippingAddress={shippingAddress}
                goToFirstStep={goToFirstStep}
                goToNextStep={goToNextStep}
                goToPreviousStep={goToPreviousStep}
                setShipping={setShipping}
                setShipingOption={setShipingOption}
                refreshComp={refreshComp}
              />
            </Fade>
          ) : null}
          {step === 3 ? (
            <Fade delay={300}>
              <Elements stripe={stripePromise} options={options}>
                <EnterPayment
                  address={shippingAddress}
                  email={email}
                  goToNextStep={goToNextStep}
                  goToFirstStep={goToFirstStep}
                  goToPreviousStep={goToPreviousStep}
                  shippingAddress={shippingAddress}
                  goToStepTwo={goToStepTwo}
                  shipping={shipping}
                />
              </Elements>
            </Fade>
          ) : null}
        </Grid>
      </Grid>
    </Fade>
  );
};

export default Checkout;
